import Vue from 'vue'
import App from './App.vue'
import AtComponents from 'at-ui'
import 'at-ui-style'
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/default.css'
import { Swatches, Sketch } from 'vue-color'

Vue.use(AtComponents)
Vue.component('VueSlider', VueSlider)
Vue.component('Swatches', Swatches)
Vue.component('Sketch', Sketch)
Vue.config.productionTip = false

new Vue({
  render: h => h(App),
}).$mount('#app')
